import { render, staticRenderFns } from "./ApiMenuItem.vue?vue&type=template&id=303fbefd&scoped=true&"
import script from "./ApiMenuItem.vue?vue&type=script&lang=js&"
export * from "./ApiMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ApiMenuItem.vue?vue&type=style&index=0&id=303fbefd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303fbefd",
  null
  
)

export default component.exports